import React, { useEffect, useState } from 'react';
import Load from './load';
import fetchAPI from '../helper/axios';
import { ImagePathurl } from '../helper/constants';
import { MediaList } from '../data/mediaModel';
import { CMS_API_BASE ,IsDevMode} from '../helper/constants';
import {  generateSlug } from '../helper/encript';
import { formatDate } from '../helper/dateFormat';

// Base URL for the API
 const API_BASE = CMS_API_BASE;

const Media: React.FC = () => {
        const [MediaData, setData] = useState<any>(null);
        const [MediaImg1, setMediaImgData1] = useState<any>();
          const [MediaImgmob1, setMediaImgData2] = useState<any>();
        const PathUrl=ImagePathurl;
        const [Mediablock, setDataBlock] = useState<MediaList[]>([]);

        const [loading, setLoading] = useState<boolean>(true);
        const [error, setError] = useState<string | null>(null);
  const [retry, setRetry] = useState(0); // for retry trigger
    useEffect(() => {
        const loadData = async () => {
          try {
           
            // About Sections
            setData(await fetchAPI('node/42'));
            setMediaImgData1(await fetchAPI('media/56/edit'));
             setMediaImgData2(await fetchAPI('media/137/edit'));
    
          } catch (err: any) {
            setError(err.message);
               // Retry after 3 seconds
        setTimeout(() => setRetry((prev) => prev + 1), 10000);
          } finally {
            setLoading(false);
          }
        };
         const fetchJobs = async () => {
            try {
            //const response = await fetch('/api/jsonapi/node/media_block?sort=-created&include=field_featured_image.field_media_image,field_media_detail_image.field_media_image');
          
             let response: Response;
                if (IsDevMode === 1) {
                  response = await fetch('/api/jsonapi/node/media_block?sort=-created&include=field_featured_image.field_media_image,field_media_detail_image.field_media_image');
                } else {
                  response = await fetch(API_BASE + '/jsonapi/node/media_block?sort=-created&include=field_featured_image.field_media_image,field_media_detail_image.field_media_image');
                }

          
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
           // const data = await response.json();
              const { data, included } = await response.json();
        
                const getImageUrl = (mediaId: string) => {
                // 1️⃣ Find media entity
                const media = included?.find(
                    (item: any) =>
                    item.type === "media--image" && item.id === mediaId
                );
        
                // 2️⃣ Find linked file entity
                const fileId = media?.relationships?.field_media_image?.data?.id;
                const file = included?.find(
                    (item: any) => item.type === "file--file" && item.id === fileId
                );
        
                // 3️⃣ Return full URL
                return file?.attributes?.uri?.url
                    ? `${file.attributes.uri.url}`
                    : null;
                };
        
                const formatted = data.map((item: any) => ({
                id: item.id,
                created: item.attributes.created,
                field_category_tag: item.attributes.field_category_tag,
                field_media_title: item.attributes.field_media_title,
                field_content: item.attributes.field_content.value,
                status: item.attributes.status,
                field_featured_url: getImageUrl(item.relationships.field_featured_image?.data?.id),
                field_media_detail_url: getImageUrl(item.relationships.field_media_detail_image?.data?.id),
         
                }));
 
        setDataBlock(formatted);
           
            } catch (error) {
            console.error('Error fetching Data:', error);
               // Retry after 3 seconds
             setTimeout(() => setRetry((prev) => prev + 1), 3000);
            }
        };

       fetchJobs();
        loadData();
      }, [retry]);

 const [currentPage, setCurrentPage] = useState<number>(1);
   

 const itemsPerPage = Number(localStorage.getItem("media_No") ?? 6);

//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = Mediablock.slice(indexOfFirstItem, indexOfLastItem);

//   const totalPages = Math.ceil(Mediablock.length / itemsPerPage);

//   // ✅ TypeScript fix: explicitly type the parameter
//   const goToPage = (pageNumber: number): void => {
//     // Optionally, add safety to avoid invalid pages
//     if (pageNumber < 1 || pageNumber > totalPages) return;
//     setCurrentPage(pageNumber);
//   };
const [selectedCategory, setSelectedCategory] = useState("all");

 // Handle category change
  const handleChange = (e:any) => {
    setSelectedCategory(e.target.value);
    setCurrentPage(1); // reset to first page when category changes
  };

  // ✅ Filter items based on selected category
//   const filteredItems =
//     selectedCategory === "all"
//       ? Mediablock
//       : Mediablock.filter(
//           (item) => item.field_category_tag === selectedCategory
//         );
const filteredItems =
  selectedCategory === "all"
    ? Mediablock.filter(item => item.status === true)
    : Mediablock.filter(
        item =>
          item.field_category_tag === selectedCategory &&
          item.status === true
      );

 // ✅ Pagination logic
  const totalPages = Math.ceil(filteredItems.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentPageItems = filteredItems.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  // ✅ Page navigation handlers
  const handlePrev = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleNext = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const handlePageClick = (page:any) => {
    setCurrentPage(page);
  };

  if (loading) return    <Load />;
    //   if (error) return <div>Error: {error}</div>;

  return (

     <>
 
    <main className="main">

        {/* Hero Section */}
        <section id="hero" className="hero section media-hero dark-background media-banner">
          <img src={MediaImg1?.thumbnail?.[0]?.url} alt="" className="hero-bg d-xl-block d-lg-block d-md-block d-sm-none w-100" loading="lazy" decoding="async" />
          <img src={MediaImgmob1?.thumbnail?.[0]?.url} alt="" className="hero-bg d-xl-none d-lg-none d-md-none d-sm-block w-100" loading="lazy" decoding="async" />

            <div className="container">
                <div className="row gy-4  justify-content-between">

                    <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 d-flex flex-column text-md-start text-sm-center justify-content-center" data-aos="fade-in">
                        
                        <label data-aos="slide-right" className="media-title-banner banner-h1">
                           {MediaData?.field_description?.[0]?.value}
                        </label>
                    </div>

                </div>
            </div>


        </section>{/* /Hero Section */}
          <section className='p-0'>
          <div className="container py-2">
            <nav aria-label="breadcrumb animated slideInDown ">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item"><a className="text-dark" href="/">Home</a></li>
                    <li className="breadcrumb-item"><a className="text-dark" href="/resources">Resources</a></li>
                  
                </ol>
            </nav>
        </div>
        </section>
        {/* About career Section */}
        <section  className="about section pt-lg-5 pt-md-5 pt-0">

            <div className="container" data-aos="fade-up" data-aos-delay="100">
                <div className="row gx-2 align-items-xl-start gy-md-5 ">

                    <div className="col-xl-12 col-sm-12 content mt-0 mt-lg-4">
                        {/*<h3>About Us</h3>*/}
                     
                         <label className="label-title" dangerouslySetInnerHTML={{ __html:MediaData?.field_media_description?.[0]?.value }} />
                    </div>

                    {/* <div className="col-xl-12 col-sm-12">
                        <div className="row gy-4 icon-boxes">
                            <div className="col-sm-12 px-xl-5 px-lg-5 px-sm-0">
                                <p className="px-xl-5 px-lg-5 px-sm-0" dangerouslySetInnerHTML={{ __html:MediaData?.field_content?.[0]?.value }} />
                            </div>

                        </div>
                    </div> */}

                </div>


                <div className="row gx-2">
                    <div className="col-sm-12">
                        {/* mediaList Section */}
                        <div id="mediaList" className=" section  media-slide pt-2">

                            <div className="container-fluid" data-aos="fade-up" data-aos-delay="100">

                                <div className="media ">
                                    <div className="media-dropdown d-flex justify-content-end ">
                                        <div className="col-lg-2" >
                                         <select className="form-select form-select-media"   value={selectedCategory}
                                               onChange={handleChange} aria-label="Default select example">
                                            <option selected value="all">All</option>
                                            
                                            {Array.from(new Set(Mediablock.map(item => item.field_category_tag))).map((tag, index) => (
                                            <option key={index} value={tag}>{tag}</option>
                                             ))}
                                           
                                            </select>
                                           
                                         </div>  </div>
                                         <div className='col-12'>
                                         <hr className='mt-3 mb-4' />
                                         </div>
                                    <div className="media-wrapper row  ">
                                        {currentPageItems.length > 0 ? (
                                           currentPageItems.map((item, index) => (
                                            <div className="media-item col-lg-4 col-sm-6 col-md-4" key={index}>
                                                <div className="media-itemwrap">
                                                    <a href={`/resources/${item.field_category_tag}/${generateSlug((item.field_media_title))}`}>
                                                        <img src={`${PathUrl}${item.field_featured_url}`} className="img-fluid" alt="" />
                                                             
                                                         <p className='dateFormat mt-2 mb-0'>{formatDate(item.created)}</p>
                                                        <h6 className="media-multiline-title"> {item.field_media_title}</h6>
                                                        <p className="media-multiline-desc d-none" dangerouslySetInnerHTML={{ __html:item.field_content }} />
                                                          
                                                    </a>
                                                </div>
                                            </div>  
                                            ))) : (
                                                <div className="media-item col-lg-12 col-md-12 col-sm-12 text-center mt-2">No Data found.</div>
                                            )}

                                      

                                    </div>
                                    <div className="row ">
                                        <div className="col-sm-12 text-center">
                                            <nav aria-label="Page navigation example">
                                                {/* <ul className="pagination justify-content-center">
                                                    <li className={`page-item ${currentPage === 1 ? 'disabled' :''}`}  onClick={() => goToPage(currentPage - 1)}
                                                       >
                                                        <a className="page-link  text-success"><span aria-hidden="true"><i className="bi bi-arrow-left"></i></span></a>
                                                    </li>
                                                      {Array.from({ length: totalPages }, (_, i) => (
        
                                                            <li className={`page-item ${currentPage === i + 1 ? 'active' :''}`}   key={i + 1}
                                                            onClick={() => goToPage(i + 1)} ><a className="page-link" aria-current="page" >{i + 1}</a></li>
                                                        ))}
                                                  
                                                  
                                                    <li className={`page-item ${currentPage === totalPages ? 'disabled' :''}`} onClick={() => goToPage(currentPage + 1)}>
                                                        <a className="page-link text-success" ><span aria-hidden="true"><i className="bi bi-arrow-right"></i></span></a>
                                                    </li> 
                                                </ul> */}
                                               {totalPages > 0 && (
                                                        <ul className="pagination justify-content-center">
                                                        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                                            <button className="page-link text-success" onClick={handlePrev}>
                                                            <i className="bi bi-arrow-left"></i>
                                                            </button>
                                                        </li>

                                                        {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                                                            <li
                                                            key={page}
                                                            className={`page-item ${page === currentPage ? "active" : ""}`}
                                                            >
                                                            <button className="page-link" onClick={() => handlePageClick(page)}>
                                                                {page}
                                                            </button>
                                                            </li>
                                                        ))}

                                                        <li
                                                            className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
                                                        >
                                                            <button className="page-link text-success" onClick={handleNext}>
                                                            <i className="bi bi-arrow-right"></i>
                                                            </button>
                                                        </li>
                                                        </ul>
                                                    )}
                                                
                                            </nav>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>{/* /Testimonials Section */}

                    </div>
                </div>

                

            </div>

        </section>{/* /About Section */}

    </main>
    </>
  );
};
export default Media
